export const dDDefaultLevelOne = [
   {
    name: "features",
    className: "flowbox dark-blueline dark-blueline",
    title: "Features",
  },
  {
    name: "defects",
    className: "flowbox dark-Orange",
    title: "Defects",
  },
  {
    name: "risk",
    className: "flowbox dark-blueline pinkline",
    title: "Risk",
  },
  {
    name: "enablers",
    className: "flowbox dark-blueline purpleline",
    title: "Enablers",
  },
  {
    name: "debt",
    className: "flowbox dark-blueline yellowline ",
    title: "Debt",
  },
  {
    name: "prodFix",
    className: "flowbox dark-blueline orangeline",
    title: "ProdFix",
  },
  {
    name: "prodFix1",
    className: "flowbox dark-blueline orangeline",
    title: "ProdFix1",
  },
];
export const dDDefaultLevelOne1 = [
  {
    name: "MINOR",
    className: "flowbox dark-blueline dark-blueline",
    title: "Low",
  },
  {
    name: "MEDIUM",
    className: "flowbox Green",
    title: "Medium",
  },
  {
    name: "MAJOR",
    className: "flowbox dark-blueline yellow-1",
    title: "High",
  },
  {
    name: "CRITICAL",
    className: "flowbox dark-blueline light-Orange",
    title: "Critical",
  },
  {
    name: "BLOCKER",
    className: "flowbox dark-blueline pinkline",
    title: "Blocker",
  },
];





